import { debounce } from 'lodash'
import React, { PureComponent } from 'react'

import { InputBase, InputBaseProps } from '@mui/material'

export class DebouncedInput extends PureComponent<DebouncedInputProps> {
  constructor(props: DebouncedInputProps) {
    super(props)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.propagateChange = debounce(this.propagateChange.bind(this), 250)
  }

  handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.propagateChange(event.target.value)
  }

  // We need to encapsulate the change, since event.target doesn't play well with debouncing
  propagateChange(search: string) {
    const { onChange } = this.props
    onChange(search)
  }

  render() {
    const { onChange, ...restProps } = this.props
    return <InputBase onChange={this.handleSearchChange} {...restProps} />
  }
}

export type DebouncedInputProps = Omit<InputBaseProps, 'onChange'> & {
  onChange: (value: string) => void
}
